import HttpClient from "../../../services/http-client";
import { IListDocumentTypesResponse } from "../../../../model/sdp/base/list-document-types-response";
import { IDashboardResponse } from "../../../../model/sdp/base/dashboard-response";

const defaultPath = 'Base';


const listDocumentTypes = async (): Promise<IListDocumentTypesResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/documentTypes`
    }).then((response) => Object.assign([] as unknown as IListDocumentTypesResponse, response.data));
};


const getDashboard = async (): Promise<IDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/dashboard`
    }).then((response) => Object.assign({} as unknown as IDashboardResponse, response.data));
};


const BaseAppService = {
     listDocumentTypes, getDashboard
};

export default BaseAppService;